<template>
	<div>
		<div class="ConfigGen"  >
			<div class="ConfigGen_values" v-if="!generated" >

				<div class="formprompt">
					<p>Please enter the following details in order to generate the configuration file.</p>
				</div>
				<form @submit.prevent="generateConfig()" >
					<div class="tableholder">
						<table>
							<tr v-for="(variable,i) in variables" :key="variable.lid" :class="{valid:isValid(values[variable.label],variable)}" >
								<th>
									<label :for="'in-'+variable.lid">
										<b>{{ variable.label }}</b>
										<span class="type">{{ variable.type }}</span>
									</label>
								</th>
								<td>
									<textarea v-if="variable.type=='textarea'" v-model="values[variable.label]" v-bind="calcVarAttrs(variable,i)" ></textarea>
									<input v-else-if="variable.type=='int'" v-model="values[variable.label]" type="number" step="1" v-bind="calcVarAttrs(variable,i)" />
									<input v-else type="text" v-model="values[variable.label]" v-bind="calcVarAttrs(variable,i)" />
									<div class="prompt" v-if="variable.prompt" >{{ variable.prompt }}</div>
								</td>
							</tr>
						</table>
					</div>
					<div class="buttonrow" >
						<button class="btn-a" :disabled="!ready_to_generate" >Generate Config</button>
					</div>
				</form>

				<!-- <ConfigGenForm
					:variables="variables"
					v-model="values"
					v-on:input="formChange"
					/> -->
			</div>

			<p  v-if="generated"  ><button class="btn-b btn-small" @click="generated=false" ><i class="fa fa-redo btn_icon"></i> Rebuild with new values</button></p>

			<div class="ConfigGen_save" v-if="generated" >
					
				<!-- <div class="values">
					<p>Used values:</p>
					<table class="pretty" >
						<tr v-for="(val,k) in values" :key="k">
							<th>{{ k }}</th>
							<td>{{ val }}</td>
						</tr>
					</table>
					<button class="btn-b btn-small" @click="generated=false" ><i class="fa fa-redo btn_icon"></i> Rebuild with new values</button>
				</div> -->

				<form @submit.prevent="createConfig"  :disabled="submitting" >
					<input style="font-size:1.3em;" v-model="save_name" type="text" class="in-base">
					<button :class="{'btn-a':1,'_btn_submitting':submitting}" >Save config</button>
				</form>
			

			</div>

			<h2  v-if="!generated" >Template</h2>

			<div class="ConfigGen_body">
				<TemplateInput
					:key="valhash"
					:value="renderTemplate"
					:disabled="!generated"
					/>
			</div>

			<div class="ConfigGen_valuesummary" v-if="generated" >
				<div>
					<p>Values used:</p>
					<button class="btn-b btn-small" @click="generated=false" ><i class="fa fa-redo btn_icon"></i> Rebuild with new values</button>
				</div>
				<div class="values">
					<table class="pretty" >
						<tr v-for="(val,k) in values" :key="k">
							<th>{{ k }}</th>
							<td>{{ val }}</td>
						</tr>
					</table>
				</div>
			</div>

		</div>

	</div>
</template>

<script>

	import TemplateInput from "../components/TemplateInput.vue";
	import ConfigGenForm from "../components/ConfigGenForm.vue";
	import Variables from '../utils/Variables';
	import Hashr from '../utils/Hashr';

	export default {

		components : {
			TemplateInput,
			ConfigGenForm,
		},

		props : ['template','latest_values'],

		data(){
			var date = new Date();
			date = date.getFullYear() + '-' +
				('00' + (date.getMonth()+1)).slice(-2) + '-' +
				('00' + date.getDate()).slice(-2) 
				+ ' ' + ('00' + date.getHours()).slice(-2)
				+ ':' + ('00' + date.getMinutes()).slice(-2) 
				+ ':' + ('00' + date.getSeconds()).slice(-2)
				;

			return {
				values : {},
				submitting : false,
				generated : false,
				generated_body : '',
				save_name : this.template.name +' - '+date,
			}
		},

		computed:{
			variables(){
				return this.template.variables;
			},
			body(){
				return this.template.template;
			},
			split_body(){
				return this.template.template.split("\n");
			},
			name(){
				return this.template.name;
			},
			valhash(){
				return Hashr(JSON.stringify(this.values)+this.generated);
			},
			renderTemplate(){
				return {
					body : this.generated ? this.generated_body : this.body,
					// body : Variables.mergeValuesIntoBody(this.variables,this.values,this.body),
					variables : this.variables,
				};
			},
			ready_to_generate(){
				return Variables.valuesAreValid(this.values,this.variables);
			},
		},

		beforeMount(){
			
			var default_values = this.variables.reduce((a,c)=>{
				if(c.default_value){
					a[c.label] = c.default_value;
				}
				return a;
			},{});

			var route_query = this.$route.query || {};
			
			var params = this.variables.reduce((a,c)=>{
				if( route_query[c.label] ){
					a[c.label] = route_query[c.label];
				}
				return a;
			},{});
			
			this.values = this.latest_values || Object.assign(default_values,params);
		},

		methods:{
			isValid(value,variable){
				return Variables.valueIsValid(value,variable);
			},
			formChange(vals){
				this.$emit('newvals', vals);
				this.$refs.render.focus();
			},
			createConfig(){
				var self = this;
				var payload = {
					values : this.values,
					config : this.generated_body,
					name : this.save_name,
					org_id : this.template.org_id,
					template_id : this.template.id,
				};
				self.submitting = true;

				return api.store('config',payload).then(function(config){
					self.$emit('update',config);
					self.$router.push({name:'config',params:{config_id:config.id}})
				}).catch(function(e){
					alert(e.message || 'Failed to create config. Try again.');
				}).then(function(){
					self.submitting = false;
				});
			},
			generateConfig(){
				if(!this.ready_to_generate) return;
				this.generated_body = Variables.mergeValuesIntoBody(this.variables,this.values,this.body);
				this.generated = true;
			},
			bodyChange(data){
				console.log(1);
			},
			calcVarAttrs(variable,position){
				var field = Variables.renderField(variable);
				return {
					autofocus : position===0,
					id : 'in-'+variable.lid,
					autocomplete : field.autocomplete,
					placeholder : field.placeholder,
				};
			},
		}
	}

</script>